import NumberFlow from '@number-flow/react';
import type { ReactElement } from 'react';

import { Checkbox } from 'src/components/ui/checkbox';
import { ConfigurationCriterionBadge } from 'src/features/configuration/configurationCriteria/ConfigurationCriterionBadge';
import { ConfigurationCriterionChildrenConfig } from 'src/features/configuration/configurationCriteria/configs/ConfigurationCriterionChildrenConfig';
import type { ConfigurationCriteriaEnum } from 'src/features/configuration/configurationCriteria/enums/ConfigurationCriteriaEnum';
import { ConfigurationCriteriaIdsEnum } from 'src/features/configuration/configurationCriteria/enums/ConfigurationCriteriaIdsEnum';
import { useConfigurationCriterion } from 'src/features/configuration/configurationCriteria/hooks/useConfigurationCriterion';
import type { OpenSessionCriterion } from 'src/services/api/getOpenSessionCriteria';

type ConfigurationCriterionProps = {
  criterionKey: ConfigurationCriteriaEnum;
  criterion: OpenSessionCriterion;
};

export function ConfigurationCriterion({
  criterionKey,
  criterion,
}: ConfigurationCriterionProps): ReactElement {
  const {
    isAddingCriteria,
    isDeletingCriteria,
    isChecked,
    handleChangeCriteria,
    handleUpdateCriteria,
  } = useConfigurationCriterion(criterion);

  return (
    <div className='flex w-full flex-wrap items-center gap-2 text-sm'>
      <ConfigurationCriterionBadge
        id={
          ConfigurationCriteriaIdsEnum[
            criterionKey as keyof typeof ConfigurationCriteriaIdsEnum
          ]
        }
      />
      <Checkbox
        checked={isChecked}
        className='ml-1 size-5 cursor-pointer'
        disabled={isAddingCriteria || isDeletingCriteria}
        onCheckedChange={(checked) => handleChangeCriteria(checked === true)}
      />
      <span>-</span>
      <ConfigurationCriterionChildrenConfig
        criterion={criterion}
        criterionKey={criterionKey}
        onUpdateCriteria={handleUpdateCriteria}
      />
      <span className='text-layout-foreground-secondary'>
        (<NumberFlow value={criterion.products.length} /> refs)
      </span>
    </div>
  );
}
